import styled from 'styled-components';
import { Tag } from 'antd';
import CustomTable from '../CustomTable';
import NestedTable from '../NestedTable';
import TextBox from 'components/TextBox';
import { IToken } from 'store/ducks/globalTypes';

export const StyledCustomTable = styled(CustomTable)<IToken>`
  .ant-table-row-expand-icon-cell {
    display: none;
  }

  .ant-table-row-level-0 {
    > .ant-table-cell {
      padding: 0 16px;

      > div {
        padding: 0 16px;
      }
    }
  }

  .nested-table {
    table-layout: fixed !important;
  }

  .ant-table-wrapper .ant-table {
    .ant-table-tbody > tr > td {
      border-bottom: ${(props) => {
        const borderColor = props.token?.tableBorderColor || '#d9d9d9';
        return `1px solid ${borderColor} !important`;
      }};
    }
  }

  .ant-table-tbody {
    .ant-table-cell:nth-child(1) > div {
      margin-left: 8px;
    }
    .ant-table-cell:nth-child(2) > div,
    .ant-table-cell:nth-child(5) > div,
    .ant-table-cell:nth-child(7) > div,
    .ant-table-cell:nth-child(8) > div,
    .ant-table-cell:nth-child(10) > div {
      margin-left: 32px;
    }
    .ant-table-cell:nth-child(3) > div {
      margin-left: 0px;
    }
    .ant-table-cell:nth-child(4) > div,
    .ant-table-cell:nth-child(6) > div,
    .ant-table-cell:nth-child(9) > div {
      margin-left: 40px;
    }
  }

  /* Force black text for Gaps column ONLY in deep navy theme */
  .deepNavyTheme & .ant-table-tbody .ant-table-cell:nth-child(1) > div,
  .deepNavyTheme & .ant-table-tbody .ant-table-cell:nth-child(1) div {
    color: #000000 !important;
  }

  /* Force black text for all text elements in deep navy theme */
  .deepNavyTheme & .ant-table-tbody .ant-table-cell > div,
  .deepNavyTheme & .ant-table-tbody .ant-table-cell div,
  .deepNavyTheme & .nested-table .ant-table-tbody .ant-table-cell > div,
  .deepNavyTheme & .nested-table .ant-table-tbody .ant-table-cell div {
    color: #000000 !important;
  }

  /* Specific targeting for Gaps Definition column with maximum specificity */
  .deepNavyTheme & .nested-table .ant-table-tbody .ant-table-cell:nth-child(1),
  .deepNavyTheme
    &
    .nested-table
    .ant-table-tbody
    .ant-table-cell:nth-child(1)
    > div,
  .deepNavyTheme
    &
    .nested-table
    .ant-table-tbody
    .ant-table-cell:nth-child(1)
    div,
  .deepNavyTheme
    &
    .nested-table
    .ant-table-tbody
    .ant-table-cell:nth-child(1)
    * {
    color: #000000 !important;
  }

  /* Move fields for rows that have both gaps and AFG */
  .nested-table.has-both-data .ant-table-tbody {
    .ant-table-cell:nth-child(3) > div,
    .ant-table-cell:nth-child(5) > div,
    .ant-table-cell:nth-child(7) > div {
      transform: translateX(-10px) !important;
    }
    .ant-table-cell:nth-child(1) > div {
      transform: translateX(1px) !important;
    }
    .ant-table-cell:nth-child(2) > div {
      transform: translateX(10px) !important;
    }
    .ant-table-cell:nth-child(4) > div {
      transform: translateX(25px) !important;
    }
    .ant-table-cell:nth-child(6) > div {
      transform: translateX(15px) !important;
    }
    .ant-table-cell:nth-child(8) > div {
      transform: translateX(60px) !important;
    }
    .ant-table-cell:nth-child(9) > div {
      transform: translateX(10px) !important;
    }
  }

  /* Move Gap fields for rows with gaps only */
  .nested-table:not(.has-both-data) .ant-table-tbody {
    .ant-table-cell:nth-child(8) > div {
      transform: translateX(25px) !important;
    }
    .ant-table-cell:nth-child(10) > div {
      transform: translateX(25px) !important;
    }
  }

  .ant-table-filter-column {
    flex-direction: row-reverse;

    .ant-dropdown-trigger {
      margin-inline: 0 5px;
    }
  }

  .ant-table-wrapper {
    .ant-table {
      margin: unset !important;
    }
  }

  .ant-spin-nested-loading {
    overflow-y: initial !important;
  }
`;

export const StyledNestedTable = styled(NestedTable)``;

export const StyledTag = styled(Tag)`
  width: 100px;
  padding: 0 9px;
  font-size: 14px;
  text-align: center;
`;

export const StyledTextBox = styled(TextBox)`
  height: 0;
  padding: unset !important;
`;
